import React from 'react';
import PropTypes from 'prop-types';
import Button from '@cotyorg/ccx-atoms/Button';
import ProductsStock from './ProductsStock';
import ProductTotalPrice from './ProductTotalPrice';
import { getCurrencySymbol, analyticsDecorator } from '../utils';

const ProductActionsRow = ({
  name,
  loading,
  products,
  displayName,
  itemsLength,
  totalProductPrices,
  getPurchaseUrlAsync,
  stockLabel,
  totalLabel,
  shippingLabel,
  buyButtonText,
  trackBuyFromRetailer,
}) => (
  <tr className="shopping-bag__row shopping-bag__row--actions">
    <td className="shopping-bag__cell shopping-bag__cell--image">
      <ProductsStock
        availableItemLength={products.length}
        itemsLength={itemsLength}
        stockLabel={stockLabel}
      />
      <br />
      <span className="hide-for-large">
        <ProductTotalPrice
          currency={getCurrencySymbol(products)}
          totalProductPrices={totalProductPrices}
        />
      </span>
    </td>

    <td
      className="
      shopping-bag__cell
      shopping-bag__cell--name
      hide-for-xsmall-only
      hide-for-small-only
      hide-for-medium-only"
    />

    <td
      className="
      shopping-bag__cell
      shopping-bag__cell--price
      hide-for-xsmall-only
      hide-for-small-only
      hide-for-medium-only"
    >
      <ProductTotalPrice
        currency={getCurrencySymbol(products)}
        totalProductPrices={totalProductPrices}
        totalLabel={totalLabel}
      />
      <br />
      <small>{shippingLabel}</small>
    </td>

    <td
      className="
      shopping-bag__cell
      shopping-bag__cell--actions
      hide-for-medium-only
      text--right"
    >
      <Button
        theme="primary"
        onClick={() => {
          getPurchaseUrlAsync(name, products);
          trackBuyFromRetailer();
        }}
        {...analyticsDecorator('buy-from-retailer', 'click')}
      >
        {loading ? 'Loading...' : `${buyButtonText} ${displayName}`}
      </Button>
    </td>

    <td
      className="
        shopping-bag__cell
        shopping-bag__cell--actions
        show-for-medium-only
        text-align-right"
      colSpan="3"
    >
      <Button
        theme="primary"
        onClick={() => {
          getPurchaseUrlAsync(name, products);
          trackBuyFromRetailer();
        }}
        {...analyticsDecorator('buy-from-retailer', 'click')}
      >
        {loading ? 'Loading...' : `${buyButtonText} ${displayName}`}
      </Button>
    </td>
  </tr>
);

ProductActionsRow.propTypes = {
  name: PropTypes.string,
  loading: PropTypes.bool,
  products: PropTypes.arrayOf(PropTypes.object),
  displayName: PropTypes.string,
  itemsLength: PropTypes.number,
  totalProductPrices: PropTypes.string,
  getPurchaseUrlAsync: PropTypes.func,
  stockLabel: PropTypes.string,
  totalLabel: PropTypes.string,
  shippingLabel: PropTypes.string,
  buyButtonText: PropTypes.string,
  trackBuyFromRetailer: PropTypes.func,
};

export default ProductActionsRow;
